module.exports = __webpack_public_path__ + "img/no-data.6962e1db.png";